import { render, staticRenderFns } from "./MachineTabs.vue?vue&type=template&id=59bc5aba&"
import script from "./MachineTabs.vue?vue&type=script&lang=ts&"
export * from "./MachineTabs.vue?vue&type=script&lang=ts&"
import style0 from "./MachineTabs.vue?vue&type=style&index=0&id=59bc5aba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports